export enum Layers {
    DOC = "doc", // main layer (context.)
    LEGAL_UNIT = "legalUnit", // default contract layer
    // sub layers
    OWNER = "owner",
    OTHER = "other",
}
